// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1xbb_","value":"styles_value__yNVut"};